export default "__VITE_ASSET__BvtchqZ7__"